import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyBPZ7N9rYStSZazr1uFjT_cRvID41UngZI",
  authDomain: "kindergarten-228b7.firebaseapp.com",
  projectId: "kindergarten-228b7",
  storageBucket: "kindergarten-228b7.appspot.com",
  messagingSenderId: "503722763313",
  appId: "1:503722763313:web:f35147d1068806be72e110",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const storage = firebase.storage();

export { db, storage };
